import { api } from "@/frontend/services/api";
import type {
  PaginationRequestDTO,
  TournamentFormatResponseDTO,
  TournamentFormatsPaginatedResponseDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/tournament-formats/private";

export const tournamentFormatService = {
  getPaginate: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<TournamentFormatsPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id?: string) => api.get<ApiResponse<TournamentFormatResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: Partial<TournamentFormatResponseDTO>) =>
    api.post<ApiResponse<TournamentFormatResponseDTO>>(BASE_URL, data),
  update: (id: string, data: Partial<TournamentFormatResponseDTO>) =>
    api.put<ApiResponse<TournamentFormatResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
